import React from 'react';
import { UserCircle, Calendar } from 'lucide-react';

/**
 * Компонент секции персональных параметров
 */
const PersonalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Текущий возраст */}
      <div>
        <label htmlFor="currentAge" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <UserCircle className="w-4 h-4 mr-2 text-indigo-500" />
          Текущий возраст
        </label>
        <input
          type="text"
          id="currentAge"
          name="currentAge"
          value={formData.currentAge}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.currentAge ? 'input-error' : ''}`}
          placeholder="Введите возраст"
        />
        {errors.currentAge && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.currentAge}
          </p>
        )}
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Ваш текущий возраст для расчета пути к финансовой независимости
        </p>
      </div>

      {/* Целевой возраст выхода на пенсию */}
      <div>
        <label htmlFor="retirementAge" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Целевой возраст выхода на пенсию
        </label>
        <input
          type="text"
          id="retirementAge"
          name="retirementAge"
          value={formData.retirementAge}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.retirementAge ? 'input-error' : ''}`}
          placeholder="Введите возраст"
        />
        {errors.retirementAge && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.retirementAge}
          </p>
        )}
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Возраст, в котором вы планируете достичь финансовой независимости
        </p>
      </div>
    </div>
  );
};

export default PersonalParametersSection;